var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('ForgotPassword',{attrs:{"type":_vm.currentDataType},on:{"sendEmailToUser":_vm.sendEmailToUser,"sendNewPassword":_vm.resetNewPassword,"goToLogin":_vm.goToLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }